import React, { useEffect } from "react";
import enamad from "../assets/images/enamad.png";
import { BsFillTelephoneFill } from "react-icons/bs";
import { MdMarkEmailRead } from "react-icons/md";
import Logo from "../assets/images/Para-Logo.png";
import { useSelector } from "react-redux";

const Footer = () => {
  return (
    <footer>
      <div className="row bg-black g-0 gap-0">
        <div className="col-md-6 col-lg-3">
          <div className="card h-100 bg-black text-light  ">
            <img
              className=" img-fluid card-img-top mx-auto mt-5"
              src={Logo}
              alt="پردازش افزار رایانه امین"
              style={{ maxWidth: "150px" }}
            />
            <div className="card-body text-center">
              <h4 className="card-title">پردازش افزار رایانه امین</h4>
              <div className="card-text">
                <h6 className="mt-3"> تاسیس سال 1401</h6>
                <h6 className="my-3">متخصص تولید اپلیکیشن و وب اپلیکیشن</h6>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-3">
          <div className="card h-100 bg-black text-light">
            <div className="card-body">
              <h4 className="card-title my-5 text-center">دسترسی سریع</h4>
              <ul className=" list-unstyled">
                <li className="my-3 mx-5">
                  <a
                    href="https://para-payesh.com/payesh"
                    className=" link-light text-decoration-none customLinkUnderlineOnHover my-5 h6"
                  >
                    سامانه پایش هوای محیطی
                  </a>
                </li>
                <li className="my-3 mx-5">
                  <a
                    href="https://para-payesh.com/sound"
                    className=" link-light text-decoration-none customLinkUnderlineOnHover my-5 h6"
                  >
                    سامانه پایش صوت محیطی
                  </a>
                </li>
                <li className="my-3 mx-5">
                  <a
                    href="https://para-payesh.com/stacks"
                    className=" link-light text-decoration-none customLinkUnderlineOnHover my-5 h6"
                  >
                    سامانه پایش خروجی دودکش های صنایع
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-3">
          <div className="card h-100 bg-black text-light  ">
            <div className="card-body te">
              <h4 className="card-title text-center my-5">تماس با ما</h4>
              <div className="card-text">
                <ul className=" list-unstyled ">
                  <li className="m-1">
                    <h6>
                      <span>آدرس : </span>
                      تهران، خیابان انقلاب، خیابان قدس، کوچه عبدالحسین زرین کوب
                      ، پلاک 16، واحد 3
                    </h6>
                  </li>
                  <li className="m-1">
                    <h6>
                      <span>تلفن : </span>
                      <a
                        href="tel:+9802166174193"
                        className="btn btn-sm btn-secondary m-1 p-2"
                        title="02166174193"
                      >
                        02166174193 <BsFillTelephoneFill />
                      </a>
                      <a
                        href="tel:+9802166951273"
                        className="btn btn-sm btn-secondary m-1 p-2"
                        title="02166951273"
                      >
                        02166951273 <BsFillTelephoneFill />
                      </a>
                    </h6>
                  </li>
                  <li className="m-1">
                    <h6>
                      <span>ایمیل : </span>
                      <a
                        href="mailto:parapayesh@gmail.com"
                        className="btn btn-secondary px-3"
                      >
                        parapayesh@gmail.com <MdMarkEmailRead />
                      </a>
                    </h6>
                  </li>
                  <li className="m-1">
                    <h6>
                      <span>فکس : </span>02166951273
                    </h6>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-3">
          <div className="card h-100 bg-black text-light d-flex">
            <div className="card-body text-center">
              <h4 className="card-title my-5">نماد تجارت الکترونیک</h4>
              <a
                referrerPolicy="origin"
                target="_blank"
                href="https://trustseal.enamad.ir/?id=454970&Code=xVTow1g3yn0T6vKDrXD7x3ww6d5GBhj6"
              >
                <img
                  referrerPolicy="origin"
                  src={enamad}
                  alt=""
                  style={{ cursor: "pointer" }}
                  code="xVTow1g3yn0T6vKDrXD7x3ww6d5GBhj6"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
  // }
};

export default Footer;
